import {securityState} from '@/utils/sessionSecurity';

let sequence = 0;
// A live editor opts in, never a request URL or a saved local-storage record.
export default {
    data: () => ({draftConnectionRegistration: null, draftConnectionActive: true}),
    computed: {
        draftConnectionOwner() {
            const user = this.$store.getters.currentUser;
            return user ? `${user.company}:${user.userId}` : '';
        },
        draftConnectionState() { return this.$store.state.appVersion; },
        draftConnectionOffline() { return this.draftConnectionState.connectionLost; },
        draftConnectionRecovery() { return this.draftConnectionState.reconnectionId; },
        draftConnectionUnavailable() {
            return this.draftConnectionOffline || this.draftConnectionState.isUpdateRequired || securityState.locked;
        },
        draftConnectionScope() {
            return this.draftConnectionActive && this.draftConnectionEligible && this.draftConnectionOwner && this.draftConnectionBoundOwner === this.draftConnectionOwner && !securityState.locked
                ? `${this.draftConnectionOwner}:${this.draftConnectionKey}` : '';
        }
    },
    watch: {
        draftConnectionUnavailable(value) {
            if (value && this._draft) this._draft.pauseConnection();
        },
        draftConnectionScope: {immediate: true, handler(value) {
            this.releaseDraftConnection();
            if (value) {
                const id = `draft-editor-${++sequence}`;
                this.draftConnectionRegistration = id;
                this.$store.commit('appVersion/registerDraftEditor', {id, owner: this.draftConnectionOwner});
            }
        }},
        draftConnectionRecovery() {
            if (this.draftConnectionScope && !this.draftConnectionUnavailable && this.draftConnectionState.status === 'ready') {
                Promise.resolve(this.resumeDraftConnection()).catch(() => { /* Editor owns visible action feedback. */ });
            }
        }
    },
    activated() { this.draftConnectionActive = true; },
    deactivated() { this.draftConnectionActive = false; this.releaseDraftConnection(); },
    beforeDestroy() { this.draftConnectionActive = false; this.releaseDraftConnection(); },
    methods: {
        releaseDraftConnection() {
            if (this.draftConnectionRegistration) this.$store.commit('appVersion/unregisterDraftEditor', this.draftConnectionRegistration);
            this.draftConnectionRegistration = null;
        },
        checkDraftConnection() { return this.$store.dispatch('appVersion/checkNow'); }
    }
};
